/**
 * Extract a filename from an HTTP `Content-Disposition` header. Supports both
 * the `filename=` and RFC 5987 `filename*=UTF-8''…` forms; falls back to
 * `fallback` when the header is missing or unparseable.
 */
export const extractDownloadFilename = (
  header: string | undefined,
  fallback: string
): string => {
  if (!header) return fallback;
  const extended = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(header);
  if (extended?.[1]) {
    try {
      return decodeURIComponent(extended[1].trim().replace(/^"|"$/g, ''));
    } catch {
      // Malformed percent-encoding — fall through to the plain filename=.
    }
  }
  const plain = /filename="?([^";]+)"?/i.exec(header);
  if (plain?.[1]) return plain[1];
  return fallback;
};
